// -----------------------------------------------------------------------------
// INDEX
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
import { inlineEditor } from "./interface/inline";
import { storyEditor } from "./interface/story";
import { textEditor } from "./interface/text";
import { insertImage } from "./menu/media";
import { elt } from "./util/dom";
export class GellertEditor extends HTMLElement {
    connectedCallback() {
        const div = elt("div", { className: "df-ed", spellcheck: false });
        this.prosemirror = null;
        this.mode = this.getAttribute("mode") || "prod";
        this.interface = this.getAttribute("interface") || "story";
        this.id = this.getAttribute("id");
        this.panel = document.getElementById(this.getAttribute("container")) || null;
        this.editor = div;
        this.append(div);
        app.ports.mountEditor.send({});
    }
    disconnectedCallback() {
        if (this.prosemirror) {
            this.prosemirror.destroy();
        }
    }
    initializeEditor(app, doc) {
        if (this.prosemirror) {
            this.prosemirror.destroy();
        }
        const containers = { inner: this.editor, outer: this, panel: this.panel };
        if (this.interface == "story") {
            this.prosemirror = storyEditor(containers, this.id, doc, app);
        }
        if (this.interface == "text") {
            this.prosemirror = textEditor(containers, this.id, doc, app);
        }
        if (this.interface == "inline") {
            this.prosemirror = inlineEditor(containers, this.id, doc, app);
        }
        app.ports.syncEditor.send({ id: this.id, doc: this.prosemirror.state.toJSON().doc });
        return this.prosemirror;
    }
    insertImage(img) {
        insertImage(this.prosemirror, img);
    }
}
export function mountHtml(editor) {
    const inner = elt("div", {
        id: "editor", className: "df-ed"
    });
    const outer = document.getElementById(editor);
    outer.appendChild(inner);
    return storyEditor({ outer, inner, panel: null }, "test", null, null);
}
